const statuses = {
	pending: 'pending',
	approved: 'approved',
	confirmed: 'confirmed',
	paid: 'paid',
	rejected: 'rejected',
	partially: 'partially' // status for affiliate cabinet
};

const locale = {
	ru: {
		pending: 'в обработке',
		approved: 'проверена',
		confirmed: 'подтверждена',
		paid: 'оплачена',
		rejected: 'отклонена',
		partially: 'частично'
	},
	en: statuses,
	uk: statuses,
	de: {
		pending: 'bevorstehend',
		approved: 'genehmigt',
		confirmed: 'bestätigt',
		paid: 'bezahlt',
		rejected: 'abgelehnt',
		partially: 'teilweise'
	},
	vi: {
		pending: 'függőben lévő',
		approved: 'ellenőrzött',
		confirmed: 'megerősített',
		paid: 'kifizetett',
		rejected: 'visszautasított',
		partially: 'részben'
	},
	th: {
		pending: 'กำลังดำเนินการ',
		approved: 'รับรองแล้ว',
		confirmed: 'ยืนยันแล้ว',
		paid: 'จ่ายแล้ว',
		rejected: 'ปฏิเสธแล้ว',
		partially: 'เพียงบางส่วน'
	}
};

locale.affiliate_dashboard = Object.assign({}, locale, {
	ru: Object.assign({}, locale.ru, { approved: 'в обработке', confirmed: 'в обработке' }),
	en: Object.assign({}, locale.en, { approved: 'pending', confirmed: 'pending' }),
	de: Object.assign({}, locale.de, { approved: 'bevorstehend', confirmed: 'bevorstehend' }),
	vi: Object.assign({}, locale.vi, { approved: 'függőben lévő', confirmed: 'függőben lévő' })
});

module.exports = {
	enum: statuses,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/payout-statuses.js